import React from "react";
import './_LoginForm.scss'
import { Form, Input, Image } from "semantic-ui-react";
import Joi from "joi";
import { Link } from "react-router-dom";
import { memo } from "react";
import { login } from "actions/authentication";
import {
  useDispatchCallback,
  useFieldset,
} from "controls/hooks";
import { Button } from "components/atoms/Button/Button";

const loginForm = { email: "", password: "" };
const loginSchema = {
  email: Joi.string()
    .email({ tlds: { allow: false } })
    .max(50)
    .required()
    .label("Email"),
  password: Joi.string().max(50).required().label("Password"),
};

const LoginForm = memo(() => {

  const {
    fields: { email, password },
    submit,
    loading,
  } = useFieldset({
    schema: loginSchema,
    source: loginForm,
    onSubmit: useDispatchCallback(login),
  });

  return (
    <div className="flex flex-column login-form container relative">
      <div className="ma4 flex flex-wrap items-center justify-center justify-between-ns">
        <a href="https://www.boldreuse.com/">
        <p className='login-form--return'>Return to Bold Reuse</p>
        </a>
      </div>
      <section className='flex flex-column justify-center items-center'>
          <Image src={process.env.REACT_APP_LOGO} alt='logo' size='small' />
      <Form
        className="w-100 center mt5 mb1 flex-column items-center justify center"
        style={{ maxWidth: 450 }}
        onSubmit={submit}
      >
        <Form.Field error={email.errored}>
          <Input
            fluid
            icon="mail"
            iconPosition="left"
            placeholder="Email"
            value={email.value}
            onChange={email.onChange}
          />
        </Form.Field>
        <Form.Field error={password.errored}>
          <Input
            fluid
            icon="lock"
            iconPosition="left"
            input="password"
            placeholder="Password"
            autoComplete="current-password"
            value={password.value}
            onChange={password.onChange}
          />
        </Form.Field>
        <Button
          type="submit"
          disabled={loading}
          loading={loading}
          primary
          fluid
          style={{ maxWidth: '180px', margin: 'auto'}}
          className='flex'
        >
          Sign In
        </Button>
        <Link to="/forgot">
          <p className='login-form--forgot'>Forgot password ?</p>
        </Link>
      </Form>
      <section className='tc mt5'>
        <p className='login-form--question mb4'>New to Bold Reuse?</p>
        <Link
          to='/signUp'
        >
        <p className='login-form--join'>Join our zero-waste community today.</p>
          </Link>
      </section>
      </section>
    </div>
  );
});

export default LoginForm;
